import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Bioseguridad/addBioseguridadAgenda`, method: 'POST', body: values, token: token})
}
